import React from 'react';
import ReactDOM from 'react-dom/client';
import '@veda/dashboard-ui/app.css';
import './index.css';
import App from './App';

window.VEDA_API_URL = process.env.REACT_APP_API_URL;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
